import React from "react";
import { formatRangeVal, getExposure, bookClass, bookText, isSuspended } from "../../casinoComponents/userSiteLastResult/refUtils";
import { RefRemark } from "../../casinoComponents/userSiteLastResult/refBits";

const BASE = import.meta.env.BASE_URL;
const SUIT = `${BASE}img/cardIcons`;
const CARD = (c) => `${BASE}img/cards/${c}.png`;
const FILMS = ["Don", "Amar Akbar Anthony", "Sahib Bibi Aur Ghulam", "Dharam Veer", "Kis Kis Ko Pyaar Karoon", "Ghulam"];
// Reference .odds-title card-character glyphs per film (A … F)
const GLYPHS = [
  [["black", "A}", false]],
  [["red", "A{"], ["black", "A]"], ["red", "A["]],
  [["black", "K}"], ["black", "Q}"], ["black", "J}"]],
  [["red", "K["], ["black", "K]"]],
  [["red", "K{"], ["black", "Q]"], ["red", "Q["], ["red", "Q{"]],
  [["red", "J{"], ["black", "J]"], ["red", "J["]],
];

const bySr = (a, b) => Number(a?.sr) - Number(b?.sr);

/**
 * V-Bollywood Casino (vbtable) bet area in the reference markup (inside .casino-detail):
 *   .main-odds (film titles, glyph row, 6 × .vodds-box back/lay + book, range)
 *   .other-odds (Odd, Black/Red .color-box, Dulha Dulhan / Barati .ddb-box)
 *   .vcasino-card-box-container (J Q K A) + .casino-remark.
 *   Markets by subtype: vbtable (films), vbtablefancy (Red, Black, J, Q, K, A, Dulha, Barati), vbtablefancy1 (Odd).
 */
export default function BtableVirtualTable({ raw = {}, exposures = {}, gameType = "vbtable" }) {
  const sub = Array.isArray(raw?.sub) ? raw.sub : [];
  const main = sub.filter((s) => s?.subtype === gameType).sort(bySr);
  const fancy = sub.filter((s) => s?.subtype === `${gameType}fancy`).sort(bySr);
  const fancy1 = sub.filter((s) => s?.subtype === `${gameType}fancy1`).sort(bySr);
  const susp = (m) => (isSuspended(m) ? " suspended" : "");
  const exp = (m) => getExposure(exposures, m?.nat);
  const minMax = (m) => (
    <div className="text-right w-100 bt-min-max">
      {"R: "}
      <span>{formatRangeVal(m?.min)}</span>-<span>{formatRangeVal(m?.max)}</span>
    </div>
  );
  const backLay = (m) => (
    <div className="casino-bl-box">
      <div className={`back casino-bl-box-item${susp(m)}`}>
        <span className="casino-box-odd">{m?.b}</span>
      </div>{" "}
      <div className={`lay casino-bl-box-item${susp(m)}`}>
        <span className="casino-box-odd">{m?.l}</span>
      </div>
    </div>
  );
  const oddsBook = (m) => (
    <div className={`w-100 odds-book text-center ${bookClass(exp(m))}`}>{bookText(exp(m))}</div>
  );
  // reference v-casinofancybook adds .lock-top to a suspended parent (.even-box)
  const evenBox = (m, name, extra = "") => (
    <div className={`even-box back-box${extra}${isSuspended(m) ? " suspended lock-top" : ""}`}>
      <div>
        <div className="dt-name">{name}</div> <div className="dt-odds">{m?.b}</div>
      </div>{" "}
      <div className={`dt-book w-100 ${bookClass(exp(m))}`}>{bookText(exp(m))}</div>
    </div>
  );
  const suits = (a, b) => (
    <>
      <img src={`${SUIT}/${a}.png`} alt="" /> <img src={`${SUIT}/${b}.png`} alt="" />
    </>
  );

  return (
    <>
      <div className="main-odds">
        <div className="odds-title">
          {FILMS.map((f, i) => (
            <React.Fragment key={f}>
              {i > 0 && " "}
              <div className="tie">
                <div>{"ABCDEF"[i]}</div> <div className="d-none-mobile">{f}</div>
              </div>
            </React.Fragment>
          ))}
        </div>{" "}
        <div className="odds-title">
          {GLYPHS.map((g, i) => (
            <React.Fragment key={i}>
              {i > 0 && " "}
              <div>
                {g.map(([color, text, block = true], j) => (
                  <React.Fragment key={text}>
                    {j > 0 && " "}
                    <span className={`card-character ${color}-card${block ? " d-block" : ""} ml-1`}>{text}</span>
                  </React.Fragment>
                ))}
              </div>
            </React.Fragment>
          ))}
        </div>{" "}
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <div className="vodds-box" key={i}>
            {backLay(main[i])} {oddsBook(main[i])}
          </div>
        ))}{" "}
        {minMax(main[0])}
      </div>{" "}
      <div className="other-odds">
        <div className="vodds-box">
          <div className="vbt-odd-name">Odd</div> {backLay(fancy1[0])} {oddsBook(fancy1[0])} {minMax(fancy1[0])}
        </div>{" "}
        <div className="color-box">
          {evenBox(fancy[1], suits("spade", "club"))} {evenBox(fancy[0], suits("heart", "diamond"))}{" "}
          {minMax(fancy[0])}
        </div>{" "}
        <div className="ddb-box">
          {evenBox(fancy[6], "DULHA DULHAN", " ddb")} {minMax(fancy[6])}
        </div>{" "}
        <div className="ddb-box">
          {evenBox(fancy[7], "BARATI", " ddb")} {minMax(fancy[7])}
        </div>
      </div>{" "}
      <div className="vcasino-card-box-container">
        <div className="vcasino-card-odds">{fancy[2]?.b}</div>{" "}
        <div className="vcasino-card-box-top">
          {["J", "Q", "K", "A"].map((c, i) => (
            <React.Fragment key={c}>
              {i > 0 && " "}
              <div className="vcasino-card-box">
                <div className={`d-inline-block${susp(fancy[i + 2])}`}>
                  <img src={CARD(c)} alt="" />
                </div>{" "}
                <div className={bookClass(exp(fancy[i + 2]))}>{bookText(exp(fancy[i + 2]))}</div>
              </div>
            </React.Fragment>
          ))}
        </div>{" "}
        {minMax(fancy[2])}
      </div>{" "}
      <RefRemark remark={raw?.remark} />
    </>
  );
}
